import styled, { css } from "styled-components";
import { parseCSS, parsePrint } from "scripts/FunctionsBundle";
import DB from "utils/printDB.json";
import { GS } from "App";
import * as _T from "@utils/ClassTypes";
import { Helmet } from "react-helmet";
import { useEffect, useRef } from "react";
import IP from "utils/ImageProvider";
import { useNavigate, useParams } from "react-router";

// ################################ INTERFACES & PROPS ################################
type a = _T.Bautizo & _T.Comunion & _T.Confirmacion & _T.Matrimonio;

type _Base = import("@utils/ClassTypes")._Base;
// SacramentosPrint => Rename all instances to use
type SacramentosPrintProps = {
  _type: string;
  _el: Partial<a>;
} & _Base;

const m = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

// ################################ RENDERING COMPONENT ################################
const _SacramentosPrint = (props: SacramentosPrintProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { type } = useParams();

  useEffect(() => {
    const a = parsePrint(props._el, type);
    window.open(
      "https://brian101016-projects.netlify.app/web/impresion/?" + a,
      "_blank"
    );
    navigate("/sacramentos/" + type);
  }, [navigate, props._el, type]);

  // ------------------------------------------------------------------------------------ HANDLE PRINT
  function handlePrint() {
    console.log("Imprimir...", qk);
  }

  // ------------------------------------------------------------------------------------ HANDLE PRINT
  /**
   * Regresa un formato de fecha correcto según el valor que le demos. Para el mes lo regresa con `m`.
   */
  function fecha(d: Date, s?: string): string {
    let dd = d?.getDate?.();
    if (!dd) return "";
    if (s === "day") return dd.toString();
    let mm = m[d.getMonth()];
    if (s === "month") return mm;
    let yy = d.getFullYear();
    if (s === "year") return yy.toString();
    if (s === "year-crop") return yy - 2000 + "";

    return dd + " de " + mm + " del " + yy;
  }

  // const qk = DB[GS.parroquia.id || "empty"]?.[props._type +".jpg"];
  // ------------------------------------------------------------------------------------ COORDS DATABASE
  const qk = DB["santuario-guadalupano"]?.[props._type];
  if (!qk) {
    return <>ERROR</>;
  }
  const url = IP._print["santuario-guadalupano"]?.[props._type] as
    | string
    | undefined;

  // ------------------------------------------------------------------------------------ INPUTS LOOP
  const childs = [] as React.JSX.Element[];
  for (const data of qk.inputs) {
    const s = data.spec as string;
    const v = data.store as string;
    let value = props._el[data.store];

    // ------------------------------------------ SPECIAL DATA
    if (v === "today") value = new Date();
    else if (v === "rector") value = GS.parroquia.parroco_encargado;
    else if (v === "sexo") value = value ? "A" : "O";
    else if (v === "testigos") value = value[s];

    if (s === "novios") value = props._el.novio + " & " + props._el.novia;
    else if (s === "continue") {
    } else value = fecha(value, s);

    // ------------------------------------------ INPUT ELEMENT
    childs.push(
      <textarea
        key={v + "-" + s}
        rows={1}
        placeholder={data.placeholder}
        defaultValue={data.value || value}
        style={{
          fontWeight: data.fontWeight,
          left: data.left,
          textAlign: data.textAlign as "center",
          top: data.top,
          width: data.width,
        }}
      />
    );
  }

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <style id={"stylesheet"}>
          {/* {css`
          @media print {
            body.landscape {
              width: 170.5mm;
              height: 229.5mm;
            }
          }
        `} */}
        </style>
      </Helmet>

      {/* ------------------------------------------------------------------------------------ PRINT BUTTON */}
      <button type={"button"} onClick={handlePrint}>
        Imprimir
      </button>

      {/* ------------------------------------------------------------------------------------ PRINT CONTAINER */}
      <div id={"content"}>
        <img
          id={"image"}
          className={"will-hide"}
          src={url}
          alt={"doc"}
          style={{
            width: qk.width,
            height: qk.height,
            top: qk.top,
            left: qk.left,
            backgroundImage: `url(${url})`,
          }}
        />
        <div ref={ref} id={"form"}>
          {childs}
        </div>
      </div>
    </div>
  );
};

// ################################ STYLES ################################
const SacramentosPrint = styled(_SacramentosPrint).attrs(
  (props: SacramentosPrintProps): SacramentosPrintProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    /* ############################################# INPUTS & TEXTAREA */
    input,
    textarea {
      font-family: "Cambria";
      font-weight: 500;
      font-size: 13px;
      text-transform: uppercase;
      background-color: #d8e1f4a8;
      border: 0;
      border-radius: 0;
      min-height: 16px;
      // height: 16px;
      /* border-bottom: 1px solid black; */
      /* border: 1px solid black; */

      resize: horizontal;

      &:active,
      &:focus-visible {
        outline: none;
      }
    }

    /* ############################################# CONTENT */
    #content {
      position: relative;
      width: 100%;
      height: 100%;
    }

    /* ############################################# DOCUMENT IMAGE */
    #image {
      position: absolute;
      background-size: cover;
    }

    /* ############################################# DOCUMENT FORM */
    #form {
      position: absolute;
      width: 100%;
      height: 100%;

      input,
      textarea {
        position: absolute;

        &:hover,
        &:active,
        &:focus-within,
        &:focus-visible {
          background-color: #d8e1f4;
        }
      }
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default SacramentosPrint;

/*

RECORTADO de la BD - Santuario - Matrimonios - antes de la presentación, después de la partida:

        {
          "store": "presentacion",
          "spec": "continue",
          "top": "151.5mm",
          "left": "78mm",
          "width": "22mm"
        },

*/
